import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Why Qualicore', href: '#why' },
  { label: 'Workflow', href: '#workflow' },
  { label: 'Features', href: '#features' },
  { label: 'Specs', href: '#specifications' },
  { label: 'Architecture', href: '#architecture' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Roadmap', href: '#roadmap' },
];

export default function Navbar({ onBookDemo }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      padding: '0 24px', height: 64,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: scrolled ? 'rgba(13,17,23,0.95)' : 'transparent',
      backdropFilter: scrolled ? 'blur(16px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : '1px solid transparent',
      transition: 'all 0.3s ease',
    }}>
      <a href="#hero" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 8,
          background: 'linear-gradient(135deg, #00C9B1, #7B3FE4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 14, fontWeight: 800, color: '#fff',
        }}>Q</div>
        <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.02em', color: '#fff' }}>Qualicore</span>
      </a>

      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }} className="nav-desktop">
        {navLinks.map(l => (
          <a key={l.href} href={l.href} style={{
            padding: '6px 11px', fontSize: 13, fontWeight: 500,
            color: 'rgba(255,255,255,0.65)', borderRadius: 6,
            transition: 'color 0.2s, background 0.2s',
          }}
          onMouseEnter={e => { e.target.style.color = '#fff'; e.target.style.background = 'rgba(255,255,255,0.06)'; }}
          onMouseLeave={e => { e.target.style.color = 'rgba(255,255,255,0.65)'; e.target.style.background = 'transparent'; }}
          >{l.label}</a>
        ))}
      </div>

      <button onClick={onBookDemo} style={{
        padding: '8px 20px', fontSize: 13, fontWeight: 600,
        background: 'linear-gradient(135deg, #00C9B1, #7B3FE4)',
        color: '#fff', borderRadius: 8, border: 'none', cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
        transition: 'opacity 0.2s',
      }}
      onMouseEnter={e => e.target.style.opacity = '0.85'}
      onMouseLeave={e => e.target.style.opacity = '1'}
      >Book a Demo</button>

      <style>{`
        @media (max-width: 768px) { .nav-desktop { display: none !important; } }
      `}</style>
    </nav>
  );
}
